module.exports = __webpack_public_path__ + "img/vessel_visitation_4_63021.819ab858.jpg";